import { MapActionConfigItem, MapActionKey } from '@ivy-monorepo/shared'

/** My Places and Footprints use an icon pill (and heart/clock marker badges); the rest a colored dot. */
const ICON_PILL: Partial<Record<MapActionKey, string>> = {
  [MapActionKey.Favorite]: '/images/map-actions/badge-heart.svg',
  [MapActionKey.History]: '/images/map-actions/badge-clock.svg',
}

/** The pill at the bottom of the map while a filter is selected (app: MapCenterBadge). */
const MapActionCenterPill = ({ item }: { item: Pick<MapActionConfigItem, 'key' | 'badgeText' | 'color'> }) => {
  const icon = ICON_PILL[item.key]
  return (
    <span className={`map-action-pill${icon ? ' map-action-pill--icon' : ''}`}>
      {icon ? (
        <img className="map-action-icon map-action-icon--white" src={icon} width={20} height={20} alt="" />
      ) : (
        <span className="map-action-pill__dot" style={{ background: item.color }} />
      )}
      {item.badgeText || '—'}
    </span>
  )
}

/** A venue marker's count badge for this filter (heart / clock for My Places / Footprints). */
export const MapActionMarkerBadge = ({ item }: { item: Pick<MapActionConfigItem, 'key' | 'color'> }) => (
  <span className="map-action-marker-badge" style={{ background: item.color }}>
    {item.key === MapActionKey.Favorite ? '♥' : item.key === MapActionKey.History ? '◷' : '12'}
  </span>
)

export default MapActionCenterPill
